var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('BannerSwiper',{attrs:{"banner":_vm.banners}}),_vm._v(" "),_c('MetaBanner'),_vm._v(" "),_c('AdvantInfo'),_vm._v(" "),_c('ProdutionList'),_vm._v(" "),_c('Access'),_vm._v(" "),_c('Comments')],1)}
var staticRenderFns = []

export { render, staticRenderFns }